
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TYPEMODULE, LoaderService, NotificationService, ErrorService, ICONS, ACTIONS, EVENTO, CONSTANT, TOOLTIPS, GridDataSource } from '../../../../shared/session/index';
import { UserService } from '../shared/user.service';
import { PageEvent, MatPaginator } from '@angular/material';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';

@Component({
  selector: 'app-user-list',
  templateUrl: 'user-list.component.html',
})

export class UserListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;

  pageSize: number;
  pageEvent: PageEvent;
  displayedColumns: string[];
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;

  constructor(
    private loaderService: LoaderService,
    private userService: UserService,
    private errorService: ErrorService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.pageSize = CONSTANT.pageSize;
    this.pageEvent = new PageEvent();
    this.clearMatPaginator();
    this.displayedColumns = ['UserID', 'Name', 'DNI', 'Telefono', 'Descripcion', 'Status'];
    this.msgErrorGet = 'Error al listar user';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
    ];
  }

  handleRowClick(row: any) {
    this.selectedRowIndex = row.ID;
    this.data.user = { ID: row.ID, Name: row.UserName };
    this.changeEvent({ evento: EVENTO.consultar, data: this.data });
  }

  clearMatPaginator() {
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.pageEvent.length = 0;
  }

  setMatPaginator() {
    this.paginator.length = this.pageEvent.length;
    this.paginator.pageIndex = this.pageEvent.pageIndex;
    this.paginator.pageSize = this.pageEvent.pageSize;
  }

  searchEmit(data: any) {
    this.buscarUser(data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onNew() {
    this.changeEvent({ evento: EVENTO.crear, data: {} });
  }

  pageEventPaginator(value) {
    this.pageEvent = value;
    this.listarUser(this.sectionBarComponent.filtro);
  }

  buscarUser(filtro: string) {
    this.clearMatPaginator();
    this.listarUser(filtro);
  }

  fabButtonEmit(action: any) {
    switch (action) {
      case ACTIONS.new:
        this.onNew();
        break;
      default:
        break;
    }
  }

  listarUser(filtro: string): void {
    this.loaderService.show();
    this.userService.listarPorUser(filtro, this.pageEvent.pageIndex, this.pageEvent.pageSize)
      .subscribe(res => {
        if (this.errorService.getMessageError(res)) {
          this.dataSource = new GridDataSource(res.Data);
          this.showHideMessageGridEmpty(Number(res.length));
          this.pageEvent.length = res.cantidadRegistro;
          this.setMatPaginator();
        }
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }
}

